var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 48,
    viewBox: "0 0 68 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_31067)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18_31067)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_18_31067)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 0.5H3C1.61929 0.5 0.5 1.61929 0.5 3V37C0.5 38.3807 1.61929 39.5 3 39.5H57C58.3807 39.5 59.5 38.3807 59.5 37V3C59.5 1.61929 58.3807 0.5 57 0.5Z",
    fill: "white",
    stroke: "#D5DFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_31067",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 6,
    width: 37,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 6H12V34.6452H49V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_31067)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 28.8714C48.9981 30.403 48.3918 31.8713 47.3142 32.954C46.2365 34.0367 44.7756 34.6455 43.252 34.6466H12V11.7752C12.0023 10.2443 12.6083 8.77664 13.6852 7.69407C14.7622 6.61151 16.2221 6.00231 17.7451 6H49V28.8714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8232 23.0115H41.1979C41.2658 23.0115 41.4233 22.9882 41.4869 22.9882C41.7285 22.9364 41.9444 22.8013 42.0972 22.6062C42.2501 22.4112 42.3302 22.1685 42.3238 21.9203C42.3231 21.6738 42.2403 21.4345 42.0886 21.2407C41.937 21.0469 41.7251 20.9097 41.4869 20.851C41.3917 20.8324 41.2947 20.8251 41.1979 20.8292H38.8232V23.0115Z",
    fill: "url(#paint0_linear_18_31067)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9265 7.93164C39.8349 7.93203 38.7881 8.3681 38.0163 9.14401C37.2444 9.91992 36.8106 10.9722 36.8102 12.0695V16.3671H42.6233C42.759 16.3629 42.8949 16.3702 43.0294 16.3889C44.3418 16.4572 45.3145 17.1401 45.3145 18.3213C45.3145 19.254 44.6583 20.0502 43.4355 20.21V20.2551C44.7696 20.3466 45.7871 21.0963 45.7871 22.2557C45.7871 23.5066 44.6568 24.3246 43.1638 24.3246H36.7871V32.7368H42.8256C43.9173 32.7368 44.9643 32.3009 45.7363 31.5249C46.5082 30.7489 46.9419 29.6964 46.9419 28.599V7.93164H40.9265Z",
    fill: "url(#paint1_linear_18_31067)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0347 18.5952C42.0392 18.3573 41.9564 18.1261 41.802 17.9457C41.6476 17.7654 41.4325 17.6485 41.1979 17.6175C41.1516 17.6175 41.0389 17.5957 40.9709 17.5957H38.8232V19.5963H40.9709C41.0474 19.6026 41.1243 19.5948 41.1979 19.573C41.4325 19.542 41.6476 19.4251 41.802 19.2448C41.9564 19.0644 42.0392 18.8331 42.0347 18.5952Z",
    fill: "url(#paint2_linear_18_31067)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.174 7.93164C17.0822 7.93164 16.0351 8.36754 15.2629 9.1435C14.4907 9.91945 14.0567 10.9719 14.0563 12.0695V22.2848C15.2126 22.8528 16.4093 23.2175 17.6075 23.2175C19.0325 23.2175 19.8015 22.3458 19.8015 21.1704V16.3512H23.3309V21.1457C23.3309 23.0098 22.1747 24.5324 18.2651 24.5324C16.8394 24.5333 15.419 24.3577 14.0361 24.0093V32.718H20.0746C20.6154 32.7178 21.1509 32.6105 21.6504 32.4022C22.1499 32.1939 22.6037 31.8886 22.9858 31.504C23.368 31.1193 23.671 30.6627 23.8775 30.1603C24.084 29.6578 24.19 29.1194 24.1894 28.5758V7.93164H18.174Z",
    fill: "url(#paint3_linear_18_31067)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5509 7.93164C28.4593 7.93203 27.4125 8.3681 26.6406 9.14401C25.8688 9.91992 25.435 10.9722 25.4346 12.0695V17.4801C26.4752 16.5938 28.2848 16.0272 31.2014 16.1623C32.2922 16.2319 33.3747 16.3991 34.436 16.6621V18.4056C33.4704 17.8867 32.4075 17.5769 31.3156 17.496C29.0985 17.3377 27.7644 18.4288 27.7644 20.3379C27.7644 22.2702 29.0985 23.3614 31.3156 23.1797C32.4046 23.093 33.4654 22.7888 34.436 22.2848V24.0282C33.3752 24.2936 32.2925 24.4609 31.2014 24.528C28.2848 24.6646 26.4752 24.0922 25.4346 23.2103V32.7586H31.4731C32.0139 32.7588 32.5493 32.652 33.049 32.4441C33.5487 32.2363 34.0027 31.9315 34.3852 31.5473C34.7677 31.1631 35.0712 30.7069 35.2783 30.2047C35.4854 29.7026 35.5921 29.1644 35.5923 28.6208V7.93164H29.5509Z",
    fill: "url(#paint4_linear_18_31067)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_31067",
    x1: 36.9223,
    y1: 22.048,
    x2: 47.0864,
    y2: 22.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_31067",
    x1: -121039,
    y1: -2079010,
    x2: -120326,
    y2: -2079010,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_31067",
    x1: -10962.9,
    y1: -12232,
    x2: -10736.7,
    y2: -12232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18_31067",
    x1: 14.0675,
    y1: 20.435,
    x2: 24.3238,
    y2: 20.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18_31067",
    x1: 25.3644,
    y1: 19.9679,
    x2: 35.4176,
    y2: 19.9679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_31067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_31067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_18_31067"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterImg2);
export default __webpack_public_path__ + "static/media/FooterImg2.cbac5348361bd47745ddf44d57c495b9.svg";
export { ForwardRef as ReactComponent };